import React from 'react';
import { BaseComponent } from '../../../../components/BaseComponent';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox, VBox } from '../../../../components/Box';
import { CompanyCreateField } from './Fields';
import { Button } from '../../../../components/Buttons';
import { selectWorks } from '../../../Api/selectors';
import { REQUEST_COMPANY } from '../../constants';
import { createCompany } from '../../actions';
import { selectCompany, selectNewCompany } from '../../selectors';
import { selectAddressTypes } from '../../../Address/selectors';
import { CompanyTransportLocations } from './AddressesCard';
import { Loader } from '../../../../components/Loader';

const Container = styled.div`
  width: 100%;
  .address-block {
    width: 80%;
    flex-wrap: wrap;
  }
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: row;

  @media (max-width: 768px) {
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  }
`;

const STATE = {
  deviveryAddressTypeId: null,
  addCompanyAddress: false,
  address: { countryId: null, typeId: 2 },
  standardLocation: null,
};

/* eslint-disable react/prefer-stateless-function */
class CompanyCreateStep4Comp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.setState(prevState => {
      const deliveryId = this.props.addressTypes.filter(t => t.name === 'delivery')[0].id;
      return {
        ...this.state,
        deviveryAddressTypeId: deliveryId,
        address: { ...this.state.address, typeId: deliveryId },
      };
    });
  }

  get company() {
    return this.props.company;
  }

  get deliveryAddresses() {
    return this.props.addresses.filter(address => address?.typeId === this.state.deviveryAddressTypeId);
  }

  create() {
    this.props.create(this.properties, this.options, result => {
      this.to(`/vehicles/${result.id}`);
    });
  }

  save() {
    this.props.onSave();
  }

  render() {
    if (this.props.work) return <Loader small />;
    return (
      <Container>
        <VBox className="pane">
          <HBox className="cols" flip={window.innerWidth < 768}>
            <Wrapper>
              <VBox className="col">
                <h2>{this.lbl('company.create.columns.transport_preferences')}</h2>
                {[
                  // 'release_before_incoming_transport',
                  // 'release_before_outgoing_transport',
                  // 'prefence_incoming_transport',
                  // 'prefence_outgoing_transport',
                ].map(type => (
                  <CompanyCreateField company_id={this.props.company_id} key={type} type={type} />
                ))}
              </VBox>
            </Wrapper>
            <HBox flip>
              <HBox left className="address-block">
                <CompanyTransportLocations company={this.props.company} />
              </HBox>
            </HBox>
            <HBox right>
              <Button className="btn" primary small>
                {this.lbl('previous')}
              </Button>
              <Button primary onClick={this.save.bind(this)} small>
                {this.lbl('save')}
              </Button>
            </HBox>
          </HBox>
        </VBox>
      </Container>
    );
  }
}

CompanyCreateStep4Comp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    company: selectCompany(ownProps.company_id),
    work: selectWorks([REQUEST_COMPANY]),
    values: selectNewCompany(),
    addressTypes: selectAddressTypes(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    create(properties, options, callback) {
      dispatch(createCompany(properties, options, callback));
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const CompanyCreateStep4 = compose(
  withConnect,
  withRouter,
)(CompanyCreateStep4Comp);
